const GW = process.env.REACT_APP_GATEWAY_URL || 'http://localhost:8001';

// ─── Sessão ───────────────────────────────────────────────────────────────────

export const salvarSessao = (token, nome, empresa, isAdmin, empresaId = null, empresas = []) => {
  localStorage.setItem('arauto_token',      token);
  localStorage.setItem('arauto_nome',       nome);
  localStorage.setItem('arauto_empresa',    empresa);
  localStorage.setItem('arauto_is_admin',   isAdmin ? '1' : '0');
  localStorage.setItem('arauto_empresa_id', empresaId ? String(empresaId) : '');
  localStorage.setItem('arauto_empresas',   JSON.stringify(empresas || []));
};

export const getToken      = () => localStorage.getItem('arauto_token');
export const getNome       = () => localStorage.getItem('arauto_nome');
export const getEmpresa    = () => localStorage.getItem('arauto_empresa');
export const getIsAdmin    = () => localStorage.getItem('arauto_is_admin') === '1';
export const getEmpresaId  = () => { const v = localStorage.getItem('arauto_empresa_id'); return v ? parseInt(v) : null; };
export const getEmpresas   = () => { try { return JSON.parse(localStorage.getItem('arauto_empresas') || '[]'); } catch { return []; } };

export const limparSessao = () => {
  ['arauto_token','arauto_nome','arauto_empresa','arauto_is_admin','arauto_empresa_id','arauto_empresas']
    .forEach(k => localStorage.removeItem(k));
};

// ─── HTTP base ────────────────────────────────────────────────────────────────

const req = async (path, opts = {}) => {
  const token = getToken();
  const res = await fetch(`${GW}${path}`, {
    ...opts,
    headers: {
      'Content-Type': 'application/json',
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
      ...opts.headers,
    },
  });
  if (res.status === 401 && !opts.skipRedirect) { limparSessao(); window.location.href = '/'; return; }
  const data = await res.json();
  if (!res.ok) throw new Error(data.detail || 'E-mail ou senha inválidos.');
  return data;
};

// ─── Auth ─────────────────────────────────────────────────────────────────────

export const login = (email, senha) =>
  req('/auth/login', { method: 'POST', body: JSON.stringify({ email, senha }), skipRedirect: true });

export const selecionarEmpresa = async (user_token, empresa_id) => {
  const data = await req('/auth/selecionar-empresa', {
    method: 'POST',
    body: JSON.stringify({ user_token, empresa_id }),
  });
  salvarSessao(data.access_token, data.nome, data.empresa, data.is_admin, data.empresa_id, data.empresas);
  return data;
};

export const trocarEmpresa = async (empresa_id) => {
  const data = await req('/auth/trocar-empresa', {
    method: 'POST',
    body: JSON.stringify({ empresa_id }),
  });
  salvarSessao(data.access_token, data.nome, data.empresa, data.is_admin, data.empresa_id, data.empresas);
  return data;
};

export const getMinhasEmpresas = () => req('/auth/minhas-empresas');

export const trocarSenhaPropria = (senha_atual, nova_senha) =>
  req('/api/me/senha', { method: 'PATCH', body: JSON.stringify({ senha_atual, nova_senha }) });

// ─── Produtos ─────────────────────────────────────────────────────────────────

export const getProdutos = (busca='', limite=50, offset=0, status='ativo') =>
  req(`/api/produtos?busca=${encodeURIComponent(busca)}&limite=${limite}&offset=${offset}&status=${status}`);

export const getProduto             = (id) => req(`/api/produtos/${id}`);
export const getProdutoUltimasCompras = (id) => req(`/api/produtos/${id}/ultimas-compras`);
export const getProdutoUltimasVendas  = (id) => req(`/api/produtos/${id}/ultimas-vendas`);

export const getEstoque = (busca='', apenasPositivo=false, limite=50, offset=0) =>
  req(`/api/estoque?busca=${encodeURIComponent(busca)}&apenas_positivo=${apenasPositivo}&limite=${limite}&offset=${offset}`);

export const getClientes = (busca='', limite=50, offset=0) =>
  req(`/api/clientes?busca=${encodeURIComponent(busca)}&limite=${limite}&offset=${offset}`);

export const getCliente = (id) => req(`/api/clientes/${id}`);

// ─── Vendas ───────────────────────────────────────────────────────────────────

export const getVendas = (p = {}) => {
  const q = new URLSearchParams();
  if (p.busca) q.set('busca', p.busca);
  if (p.di)    q.set('di',    p.di);
  if (p.df)    q.set('df',    p.df);
  q.set('limite', p.limite || 50);
  q.set('offset', p.offset || 0);
  return req(`/api/vendas?${q}`);
};

export const getVenda = (id) => req(`/api/vendas/${id}`);

export const getVendasHorario = (di, df) => {
  const q = new URLSearchParams();
  if (di) q.set('di', di);
  if (df) q.set('df', df);
  return req(`/api/vendas/horario?${q}`);
};

export const getVendasPorPagamento = (di, df) => {
  const q = new URLSearchParams();
  if (di) q.set('di', di);
  if (df) q.set('df', df);
  return req(`/api/vendas/por-pagamento?${q}`);
};

export const getVendasTopProdutos = (di, df, limite = 20) => {
  const q = new URLSearchParams({ limite });
  if (di) q.set('di', di);
  if (df) q.set('df', df);
  return req(`/api/vendas/top-produtos?${q}`);
};

// ─── Dashboard ────────────────────────────────────────────────────────────────

export const getDashboardKpis = (di, df) => {
  const q = new URLSearchParams();
  if (di) q.set('di', di);
  if (df) q.set('df', df);
  return req(`/api/dashboard/kpis?${q}`);
};

export const getDashboardTopDepartamentos = (di, df, limite = 10) => {
  const q = new URLSearchParams({ limite });
  if (di) q.set('di', di);
  if (df) q.set('df', df);
  return req(`/api/dashboard/top-departamentos?${q}`);
};

// ─── Financeiro ───────────────────────────────────────────────────────────────

export const getContasPagar = (di, df, status = '') => {
  const q = new URLSearchParams();
  if (di)           q.set('di',     di);
  if (df)           q.set('df',     df);
  if (status !== '') q.set('status', status);
  return req(`/api/financeiro/contas-pagar?${q}`);
};

export const getContasReceber = (di, df, status = '') => {
  const q = new URLSearchParams();
  if (di)           q.set('di',     di);
  if (df)           q.set('df',     df);
  if (status !== '') q.set('status', status);
  return req(`/api/financeiro/contas-receber?${q}`);
};

// ─── Compras ──────────────────────────────────────────────────────────────────

export const getComprasPorProduto = (di, df) => {
  const q = new URLSearchParams();
  if (di) q.set('di', di);
  if (df) q.set('df', df);
  return req(`/api/compras/por-produto?${q}`);
};

export const getComprasPorDepartamento = (di, df) => {
  const q = new URLSearchParams();
  if (di) q.set('di', di);
  if (df) q.set('df', df);
  return req(`/api/compras/por-departamento?${q}`);
};

export const getComprasNotasFiscais = (di, df) => {
  const q = new URLSearchParams();
  if (di) q.set('di', di);
  if (df) q.set('df', df);
  return req(`/api/compras/notas-fiscais?${q}`);
};

// ─── Admin — Empresas ─────────────────────────────────────────────────────────

export const adminGetEmpresas    = ()          => req('/admin/empresas');
export const adminGetEmpresa     = (id)        => req(`/admin/empresas/${id}`);
export const adminCriarEmpresa   = (dados)     => req('/admin/empresas', { method: 'POST', body: JSON.stringify(dados) });
export const adminEditarEmpresa  = (id, dados) => req(`/admin/empresas/${id}`, { method: 'PUT', body: JSON.stringify(dados) });
export const adminDeletarEmpresa = (id)        => req(`/admin/empresas/${id}`, { method: 'DELETE' });
export const adminToggleEmpresa  = (id)        => req(`/admin/empresas/${id}/toggle`, { method: 'PATCH' });

// ─── Admin — Usuários ─────────────────────────────────────────────────────────

export const adminGetUsuarios    = ()          => req('/admin/usuarios');
export const adminGetUsuario     = (id)        => req(`/admin/usuarios/${id}`);
export const adminCriarUsuario   = (dados)     => req('/admin/usuarios', { method: 'POST', body: JSON.stringify(dados) });
export const adminEditarUsuario  = (id, dados) => req(`/admin/usuarios/${id}`, { method: 'PUT', body: JSON.stringify(dados) });
export const adminDeletarUsuario = (id)        => req(`/admin/usuarios/${id}`, { method: 'DELETE' });
export const adminToggleUsuario  = (id)        => req(`/admin/usuarios/${id}/toggle`, { method: 'PATCH' });
export const adminResetarSenha   = (id, nova_senha) => req(`/admin/usuarios/${id}/senha`, { method: 'PATCH', body: JSON.stringify({ nova_senha }) });

// ─── Admin — Logs de acesso ───────────────────────────────────────────────────

export const adminGetLogsAcesso = ({ di, df, usuario_id, sucesso, busca, limite = 100, offset = 0 } = {}) => {
  const q = new URLSearchParams({ limite, offset });
  if (di !== undefined && di !== null)           q.set('di',          di);
  if (df !== undefined && df !== null)           q.set('df',          df);
  if (usuario_id !== undefined && usuario_id !== null) q.set('usuario_id', usuario_id);
  if (sucesso !== undefined && sucesso !== null) q.set('sucesso',     sucesso);
  if (busca)                                     q.set('busca',       busca);
  return req(`/admin/logs/acesso?${q}`);
};
